export enum eEntityRevisionType {
  ADD = 'ADD',
  MOD = 'MOD',
  DEL = 'DEL',
}
